import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'

import DateRange from '../../../commons/components/DateRange'
import Pagination from '../../../commons/components/Paginations'
import AS from '../../Login/Service/Authentication'
import CS from '../../../commons/services/Common'

class History extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: [],
            totalCount: 0,
            pageSize: 0,
            perPageSize: 10,
            currentPage: 1,
            fromDate: '',
            toDate: ''
        }
        this.getHistory = this.getHistory.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    componentDidMount() {
        this.getHistory(1);
    }

    async getHistory(pageIndex) {
        let constructorId = AS.getLoggedInId();
        let params = {
            isPaging: true,
            start: (pageIndex-1) * 10,
            length: 10,
            searchType: CS.$("#searchType"),
            keyword: CS.$("#keyword"),
            fromDate: this.state.fromDate,
            toDate: this.state.toDate
        }

        await axios.get(`/cst/api/plant-issue/history/${constructorId}`, { params
        }).then(res => {
            this.setState({
                items: res.data.data,
                totalCount: res.data.recordsTotal,
                pageSize: Math.ceil(res.data.recordsTotal / 10),
                currentPage: pageIndex
            });
        }).catch(error => {
            CS.notification("error", error.message)
        });
    }

    handleDateChange(ranges) {
        this.setState({
            fromDate: ranges[0],
            toDate: ranges[1]
        })
    }

    render() {

        const { items, totalCount, pageSize, perPageSize, currentPage} = this.state

        return (
            <>
                <div className="page-tit gray">
                    <div className="container f-stack">
                        <h2 className="tit">현장출동 내역</h2>
                        <div className="lookUp-btn">
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="top-search">
                        <div className="txt"><strong>전체보기</strong> 총 {totalCount}개</div>
                        <div className="search">
                            <form onSubmit={e => e.preventDefault()}>
                                <DateRange handleDateChange={this.handleDateChange} />
                                &nbsp;
                                <select id="searchType" title="검색선택">
                                    <option value="">검색종류</option>
                                    <option value="contact">연락처</option>
                                    <option value="plant">발전소명</option>
                                </select>
                                <span className="search">
                                    <input type="text" id="keyword" placeholder="입력" />
                                    <input type="hidden" />
                                    <button type="button" className="material-icons" onClick={() => this.getHistory(1)}>search</button>
                                </span>
                            </form>
                        </div>
                    </div>

                    <div className="table-wrapper">
                        <table className="h-table">
                            <colgroup>
                                <col style={{width: "10%"}}/>
                                <col />
                                <col style={{width: "18%"}}/>
                                <col style={{width: "18%"}}/>
                                <col style={{width: "18%"}}/>
                                <col style={{width: "18%"}}/>
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>번호</th>
                                    <th>발전소명</th>
                                    <th>보증 완료 기간</th>
                                    <th>연락처</th>
                                    <th>이슈 업데이트 일시</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    items.length > 0
                                    ?   items.map((row, index) => (
                                            <tr key={row.id}>
                                                <td>
                                                    <label className="num">
                                                        { totalCount - ((currentPage-1)*perPageSize + index) }
                                                    </label>
                                                </td>
                                                <td>{row.name}</td>
                                                <td>{row.serviceWarrantyDt}</td>
                                                <td>{row.contactNum}</td>
                                                <td>{row.issueEndingDt}</td>
                                                <td>
                                                    <Link to={"/plant-status/issue/history-detail/" + row.plantId} className="btn sm">과거 현장출동 내역({row.cnt}회)</Link>
                                                </td>
                                            </tr>
                                        ))
                                    :   <tr>
                                            <td colSpan="6">현장출동 내역이 존재하지 않습니다.</td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="paging-wrap">
                        <Pagination handlePagingChange={this.getHistory} count={pageSize} />
                    </div>
                </div>
            </>
        )
    }
}

export default History
